import { createStyles, makeStyles } from '@material-ui/core';
import { IMG_BG, BG_OVERLAY, OVAL_BLUE } from 'shared/constants/ASSETS_URL';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_CONTAINER_BORDER } = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    bodyContainer: {
      backgroundSize: 'cover',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '15px',
      minHeight: '100vh',
    },
    newBodyContainer: {
      backgroundSize: 'cover',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '15px',
      minHeight: '100vh',
      // Covers the background image by a solid color, remove for now to see image. Revert if it is intended
      // backgroundImage: 'radial-gradient(circle at 50% 20%, #1e3f70, #09111d 37%)',
    },
    backgroundContainer: {
      top: 0,
      width: '100%',
      height: 'calc(100vh - 60%)',
      display: 'flex',
      zIndex: -1,
      overflow: 'hidden',
      position: 'fixed',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundImage: `url(${IMG_BG})`,
      backgroundSize: 'auto 100%',
      backgroundRepeat: 'repeat',
      backgroundPosition: 'center',
      opacity: 0.5,
      [theme.breakpoints.down('xs')]: {},
    },
    bgImage: {
      height: 'calc(100vh - 60%)',
      width: 'auto',
    },
    bgImageOverlay: {
      width: '100%',
      height: 'calc(100vh - 69%)',
      position: 'absolute',
      backgroundImage: `url(${BG_OVERLAY})`,
      backgroundRepeat: 'repeat',
      backgroundSize: 'auto calc(100vh - 60%)',
    },
    bgNewTalent: {
      top: -30,
      width: '100%',
      height: 'calc(100vh - 60%)',
      display: 'flex',
      zIndex: -1,
      overflow: 'hidden',
      position: 'fixed',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundSize: 'auto 150%',
      backgroundPosition: 'center',
      opacity: 0.4,
      [theme.breakpoints.down('xs')]: {},
      backgroundImage: `url(${OVAL_BLUE})`,
      backgroundRepeat: 'no-repeat',
    },
    mainContainer: {
      width: '420px',
      background: 'none !important',
      boxShadow: 'none !important',
      [theme.breakpoints.down(500)]: {
        width: '100%',
      },
      '& fieldset': {
        border: `solid 1px ${DARK_CONTAINER_BORDER}`,
      },
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    },
    logoContainer: {
      padding: '0px 20px 50px 20px',
    },
    logoContainerWithoutHeading: {
      padding: '0px 20px 50px 20px',
    },
    logoContainerForSendVerification: {
      padding: '0px 20px 50px 20px',
    },
    logoCls: {
      height: 'auto',
      width: '100%',
    },
    logoClsRegister: {
      height: 'auto',
      width: '80%',
    },
    heading: {
      fontSize: 40,
      marginBottom: 10,
    },
    subHeading: {
      fontSize: 16,
    },
    registerHeading: {
      fontSize: 30,
      marginBottom: 10,
    },
    registerLogoCls: {
      height: 'auto',
      width: '80%',
    },
  }),
);
